export const GAME_CREATE = 'GAME_CREATE';
export const GAME_ADD_ROUND = 'GAME_ADD_ROUND';
export const GAME_ADD_PLAYER = 'GAME_ADD_PLAYER';
export const GAME_REMOVE_PLAYER = 'GAME_REMOVE_PLAYER';
export const GAME_GET_PLAYER_VALUE = 'GAME_GET_PLAYER_VALUE'; //probably a selector?
export const GAME_SET_CURRENT = 'GAME_SET_CURRENT';

export const PLAYER_CREATE = 'PLAYER_CREATE';
export const PLAYER_EDIT_NAME = 'PLAYER_EDIT_NAME';

export const ROUND_CREATE = 'ROUND_CREATE';
export const ROUND_SET = 'ROUND_SET';
export const ROUND_ADD_STACK = 'ROUND_ADD_STACK';
export const ROUND_REMOVE_STACK = 'ROUND_REMOVE_STACK';

export const STACK_CREATE = 'STACK_CREATE';
export const STACK_DELETE = 'STACK_DELETE';
export const STACK_ADD_CARD = 'STACK_ADD_CARD';
export const STACK_REMOVE_CARD = 'STACK_REMOVE_CARD';
export const STACK_EDIT_GOLD = 'STACK_EDIT_GOLD';
export const STACK_EDIT_SILVER = 'STACK_EDIT_SILVER';
export const STACK_GET_VALUE = 'STACK_GET_VALUE'; //probably a selector?
